import React, { Fragment } from 'react'
import { DateTime } from 'luxon'

import { DI } from 'modules'
import HelmetWrap from 'components/helmet-wrap'
import Component from 'components/component'
import page from 'hoc/page'
import frontload from 'hoc/frontload'

import 'submodules/responsivestyles/src/less/about.less'

export class TOSPage extends Component {
  static preload(props) {
    const slug = 'terms'
    return props.actions.frontpages.getFrontPage(slug)
  }

  render() {
    const tosInfo = this.props.tos.tosInfo.payload
    const meta_tag = this.props.frontpages.info.payload.meta_tag
    const strings = this.props.common.strings

    return (
      <Fragment>
        <HelmetWrap {...(meta_tag || {})} page="terms" />

        <section dir="ltr" className="content">
          <div className="iwrap not-found-page">
            <div className="about-container">
              <div
                dangerouslySetInnerHTML={{
                  __html: tosInfo.content,
                }}
              />
              {tosInfo.updated_at && (
                <div style={{ textAlign: 'right', marginTop: '30px' }}>
                  {strings.last_updated}{' '}
                  {DateTime.fromISO(tosInfo.updated_at).toFormat('MMMM yyyy')}
                </div>
              )}
            </div>
          </div>
        </section>
      </Fragment>
    )
  }
}

export default page(DI(['frontpages', 'tos'])(frontload(TOSPage)))
